<template>
  <nav aria-label="Pagination">
    <ul class="c-pagination">
      <li class="c-pagination__item">
        <button class="c-pagination__link--prev" type="button" rel="prev" v-bind:disabled="!showPreviousPage" v-on:click="getPreviousPageResults">
          <span class="visually-hidden">Previous page</span>
          <svg class="c-pagination__link--prev-arrow" focusable="false" aria-hidden="true">
            <use xlink:href="#prev" />
          </svg>
        </button>
      </li>
      <li class="c-pagination__item" v-for="pageNumber in previousPageNumbers" :key="pageNumber">
        <button class="c-pagination__link" type="button" v-bind:aria-label="`Page ${pageNumber}`" v-on:click="getPageResults(pageNumber)">{{pageNumber}}</button>
      </li>
      <li class="c-pagination__item is-active">
        <span class="c-pagination__current" v-bind:aria-label="currentPageAria">{{currentPage}}</span>
      </li>
      <li class="c-pagination__item" v-for="pageNumber in nextPageNumbers" :key="pageNumber">
        <button class="c-pagination__link" type="button" v-bind:aria-label="`Page ${pageNumber}`" v-on:click="getPageResults(pageNumber)">{{pageNumber}}</button>
      </li>
      <li class="c-pagination__item">
        <button class="c-pagination__link--next" type="button" rel="next" v-bind:disabled="!showNextPage" v-on:click="getNextPageResults">
          <span class="visually-hidden">Next page</span>
          <svg class="c-pagination__link--next-arrow" focusable="false" aria-hidden="true">
            <use xlink:href="#next" />
          </svg>
        </button>
      </li>
    </ul>
  </nav>
</template>

<script>
export default {
  name: "SearchPaging",
  props: {
    currentPage: {
      default: 1,
      type: Number
    },
    searchType: {
      type: String
    },
    totalPages: {
      default: 1,
      type: Number
    }
  },
  computed: {
    currentPageAria() {
      return `Current page ${this.currentPage}`;
    },
    nextPageNumbers() {
      let nextPageNumbers = [];
      if (this.currentPage === 1) {
        for (let i = this.currentPage + 1; i <= this.currentPage + 4 && i <= this.totalPages; i++) {
          nextPageNumbers.push(i);
        }
      }
      else if (this.currentPage === 2) {
        for (let i = this.currentPage + 1; i <= this.currentPage + 3 && i <= this.totalPages; i++) {
          nextPageNumbers.push(i);
        }
      }
      else {
        for (let i = this.currentPage + 1; i <= this.currentPage + 2 && i <= this.totalPages; i++) {
          nextPageNumbers.push(i);
        }
      }
      return nextPageNumbers;
    },
    previousPageAria() {
      return `Page ${this.previousPageNumber}`;
    },
    previousPageNumbers() {
      let previousPageNumbers = [];
      if (this.currentPage === this.totalPages) {
        for (let i = this.currentPage - 4; i <= this.currentPage - 1 && i >= 1; i++) {
          previousPageNumbers.push(i);
        }
      }
      else if (this.currentPage === this.totalPages - 1) {
        for (let i = this.currentPage - 3; i <= this.currentPage - 1 && i >= 1; i++) {
          previousPageNumbers.push(i);
        }
      }
      else if (this.currentPage === 2) {
        for (let i = this.currentPage - 1; i <= this.currentPage - 1 && i >= 1; i++) {
          previousPageNumbers.push(i);
        }
      }
      else {
        for (let i = this.currentPage - 2; i <= this.currentPage - 1 && i >= 1; i++) {
          previousPageNumbers.push(i);
        }
      }
      return previousPageNumbers;
    },
    showNextPage() {
      return (this.currentPage < this.totalPages);
    },
    showPreviousPage() {
      return (this.currentPage > 1);
    },
    previousPageNumber() {
      return (this.currentPage - 1);
    },
    nextPageNumber() {
      return (this.currentPage + 1);
    }
  },
  methods: {
    getNextPageResults() {
      this.$emit('getResults', this.nextPageNumber, this.searchType);
    },
    getPageResults(pageNumber) {
      this.$emit('getResults', pageNumber, this.searchType);
    },
    getPreviousPageResults() {
      this.$emit('getResults', this.previousPageNumber, this.searchType);
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/components/reportAProblem/results/SearchPaging.vue